import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaHome, FaShoppingCart, FaSearch, FaUser, FaClipboardList, FaHeart, FaMapMarkerAlt, FaSignOutAlt, FaUserEdit, FaTimes } from "react-icons/fa";
import { globalStore } from "stores/globalStore";
import useAuthStore from "stores/useAuthStore";
import Service from "services/service";
import "./MobileBottomNav.css";

const tabs = [
  { label: "Home", icon: FaHome, path: "/" },
  { label: "Search", icon: FaSearch, path: null },
  { label: "Cart", icon: FaShoppingCart, path: "/cart" },
  { label: "Profile", icon: FaUser, path: null },
];

const profileMenuItems = [
  { label: "My Profile", icon: FaUserEdit, path: "/userprofile", section: "profile" },
  { label: "My Orders", icon: FaClipboardList, path: "/userprofile", section: "orders" },
  { label: "My Address", icon: FaMapMarkerAlt, path: "/userprofile", section: "address" },
  { label: "Wishlist", icon: FaHeart, path: "/userprofile", section: "wishlist" },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { cartCount, productOverviewData } = globalStore();
  const { logout } = useAuthStore();
  const [showSearch, setShowSearch] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  const handleTab = (tab) => {
    if (tab.label === "Search") {
      setShowSearch((prev) => !prev);
      setShowProfile(false);
      return;
    }
    if (tab.label === "Profile") {
      setShowProfile((prev) => !prev);
      setShowSearch(false);
      return;
    }
    setShowSearch(false);
    setShowProfile(false);
    navigate(tab.path);
  };

  const handleProfileItem = (item) => {
    setShowProfile(false);
    navigate(item.path, { state: { section: item.section } });
  };

  const handleLogout = () => {
    setShowProfile(false);
    logout();
    navigate("/signup");
  };

  const handleQueryChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    if (val.trim()) {
      setSuggestions(
        productOverviewData.filter((p) =>
          p.name.toLowerCase().includes(val.toLowerCase())
        )
      );
    } else {
      setSuggestions([]);
    }
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (!query.trim()) return;
    try {
      const res = await Service.searchProducts(query.trim());
      navigate("/productlisting", { state: { searchResults: res.data } });
    } catch {}
    setShowSearch(false);
    setQuery("");
    setSuggestions([]);
  };

  const handleSuggestionClick = async (product) => {
    try {
      const res = await Service.searchProducts(product.name);
      navigate("/productlisting", { state: { searchResults: res.data } });
    } catch {}
    setShowSearch(false);
    setQuery("");
    setSuggestions([]);
  };

  const isActive = (path) => path && location.pathname === path;

  return (
    <>
      {showSearch && (
        <div className="mobile-search-overlay">
          <form onSubmit={handleSearchSubmit} className="mobile-search-form">
            <input
              autoFocus
              type="text"
              placeholder="Search products..."
              value={query}
              onChange={handleQueryChange}
            />
            <button type="button" className="mobile-search-close" onClick={() => { setShowSearch(false); setQuery(""); setSuggestions([]); }}>✕</button>
          </form>
          {suggestions.length > 0 && (
            <div className="mobile-search-suggestions">
              {suggestions.map((p) => (
                <div key={p._id || p.id} className="mobile-search-item" onClick={() => handleSuggestionClick(p)}>
                  <img src={p.primaryImage} alt={p.name} />
                  <div>
                    <span className="mobile-search-name">{p.name}</span>
                    <span className="mobile-search-cat">{p.category}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {showProfile && (
        <>
          <div className="mobile-profile-backdrop" onClick={() => setShowProfile(false)} />
          <div className="mobile-profile-menu">
            <div className="mobile-profile-menu__header">
              <span>My Account</span>
              <button onClick={() => setShowProfile(false)}><FaTimes /></button>
            </div>
            {profileMenuItems.map((item) => (
              <button key={item.label} className="mobile-profile-menu__item" onClick={() => handleProfileItem(item)}>
                <item.icon className="mobile-profile-menu__icon" />
                <span>{item.label}</span>
              </button>
            ))}
            <button className="mobile-profile-menu__item mobile-profile-menu__logout" onClick={handleLogout}>
              <FaSignOutAlt className="mobile-profile-menu__icon" />
              <span>Logout</span>
            </button>
          </div>
        </>
      )}

      <nav className="mobile-bottom-nav">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            className={`mobile-bottom-nav__tab ${isActive(tab.path) ? "active" : ""} ${tab.label === "Search" && showSearch ? "active" : ""} ${tab.label === "Profile" && (showProfile || location.pathname === "/userprofile") ? "active" : ""}`}
            onClick={() => handleTab(tab)}
          >
            <div className="mobile-bottom-nav__icon-wrap">
              <tab.icon className="mobile-bottom-nav__icon" />
              {tab.label === "Cart" && cartCount > 0 && (
                <span className="mobile-bottom-nav__badge">{cartCount}</span>
              )}
            </div>
            <span className="mobile-bottom-nav__label">{tab.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
};

export default MobileBottomNav;
